import createReducer from "./createReducer";
import * as types from "../constants/ActionTypes";
import { Reducer } from "redux";
import { ActionPayload, ID } from "../../types";
import {
  DisabledMultiplePayload,
  DisabledSinglePayload,
} from "../actions/disabledActions";

export type DisabledState = ID[];
type DisabledReducer<T> = Reducer<DisabledState, ActionPayload<T>>;

const addDisabled: DisabledReducer<DisabledSinglePayload> = (state, action) => {
  if (!state) return [];
  const { payload } = action;
  const { id } = payload;
  if (!state.includes(id)) return [...state, id];
  return state;
};

const removeDisabled: DisabledReducer<DisabledSinglePayload> = (
  state,
  action
) => {
  if (!state) return [];
  const { payload } = action;
  const { id } = payload;
  const filtered = state.filter((el) => el !== id);
  return [...filtered];
};

const addMultipleDisabled: DisabledReducer<DisabledMultiplePayload> = (
  state,
  action
) => {
  if (!state) return [];
  const { payload } = action;
  const { ids } = payload;
  return [...state, ...ids];
};

const removeMultipleDisabled: DisabledReducer<DisabledMultiplePayload> = (
  state,
  action
) => {
  if (!state) return [];
  const { payload } = action;
  const { ids } = payload;
  const filtered = state.filter((el) => !ids.includes(el));
  return [...filtered];
};
const disabledReducer = createReducer<DisabledState>([], {
  [types.ADD_DISABLED]: addDisabled,
  [types.REMOVE_DISABLED]: removeDisabled,
  [types.ADD_MULTIPLE_DISABLED]: addMultipleDisabled,
  [types.REMOVE_MULTIPLE_DISABLED]: removeMultipleDisabled,
});
export default disabledReducer;
